var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "pil ned",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.866682 1.06663C1.38215 0.551169 2.21788 0.551168 2.73335 1.06663L7.93335 6.26663L13.1333 1.06663C13.6488 0.551169 14.4846 0.551168 15 1.06663C15.5155 1.5821 15.5155 2.41784 15 2.9333L7.93335 9.99997L0.866682 2.9333C0.351216 2.41783 0.351217 1.5821 0.866682 1.06663Z",
    fill: "#2098FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.867a498e.svg";
export { ForwardRef as ReactComponent };